import { useState, ReactNode } from 'react'
import './Accordion.css'
import { ChevronDownIcon, ChevronRightIcon } from './icons'

export interface AccordionItem {
    title: ReactNode
    content: ReactNode
}

interface AccordionProps {
    items: AccordionItem[]
}

export default function Accordion({ items }: AccordionProps) {
    const [openIndex, setOpenIndex] = useState<number | null>(null)

    const toggleItem = (index: number) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    return (
        <div className="accordion">
            {items.map((item, index) => (
                <div key={index} className="accordion-item">
                    <div
                        className="accordion-header"
                        onClick={() => toggleItem(index)}
                        aria-expanded={openIndex === index}
                        tabIndex={0}
                    >
                        {item.title}
                        <span className="accordion-icon">
                            {openIndex !== index ? <ChevronRightIcon /> : <ChevronDownIcon />}
                        </span>
                    </div>
                    <div
                        className={`accordion-content ${openIndex === index ? 'open' : ''}`}
                    >
                        <div className="accordion-content-inner">
                            {item.content}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
